/**
 * A DaForge-eredmények a közös `test_results` táblában `daforge-<kiadás>` verzió-kulccsal élnek.
 * Külön modul, hogy a hook a tartalom-fájl betöltése nélkül tudja kiszűrni őket.
 */
export const DAFORGE_VERSION_PREFIX = 'daforge-';

/** A DTO `MaxLength(20)`: `daforge-` (8) + `YYYY-MM-DD` (10) = 18. */
export function daforgeVersion(releaseId: string): string {
  return `${DAFORGE_VERSION_PREFIX}${releaseId}`;
}

export function isDaforgeVersion(version: string): boolean {
  return version.startsWith(DAFORGE_VERSION_PREFIX);
}
